import React, { useState } from 'react';
import { Modal, Backdrop, Fade, TextField, Button, Box, Typography } from '@mui/material';
import axios from 'axios';

const TrocarSenha = ({ open, handleClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleTrocarSenha = async () => {
    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    try {
      if (!email || !password || !confirmPassword) {
        setError('Por favor, preencha todos os campos.');
        return;
      }

      await axios.post(`${process.env.REACT_APP_API_URL}/trocar-senha`, {
        email,
        new_password: password,
        confirm_new_password: confirmPassword,
      });

      setError('');
      handleClose();
      alert('Senha alterada com sucesso!');
    } catch (err) {
      setError('Erro ao trocar a senha. Por favor, tente novamente.');
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'white', // Definindo o fundo branco
            boxShadow: 24,
            p: 4,
            width: '20%',
            maxWidth: '400px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)', // Centralizando o modal
            borderRadius: '8px', // Definindo bordas arredondadas
            '@media (max-width:600px)': {
              width: '70%',
            },
          }}
        >
          <Typography variant="h6" component="h2">
            Trocar Senha
          </Typography>
          {error && <Typography color="error">{error}</Typography>}
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ marginBottom: '1em', width: '100%' }}
          />
          <TextField
            label="Nova Senha"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ marginBottom: '1em', width: '100%' }}
          />
          <TextField
            label="Confirmar Nova Senha"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ marginBottom: '2em', width: '100%' }}
          />
          <Button variant="contained" color="primary" onClick={handleTrocarSenha}>
            Trocar Senha
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default TrocarSenha;
